import React from 'react';
import { useParams } from 'react-router-dom';
import { ProgramPage as NewProgramPage } from '@applyboard/ab-program';
import { PageWrapper } from '~/ab-common/src';

export default function ProgramPage() {
  const { id, school_id }: { id: string; school_id: string } = useParams();

  return (
    <PageWrapper>
      <NewProgramPage schoolSlug={school_id} programSlug={id} />
    </PageWrapper>
  );
}
